export class PageGuid {
    static CurrentPageGuid: string;

    public static SetPageGuid(guid: string) {
        this.CurrentPageGuid = guid;
    }
}